import { useCallback } from "react";
import { fetchMemberPathways } from "./learnerApi";
import useMemberRead from "./useMemberRead";

/**
 * `GET /client/pathways`: the signed-in learner's pathways on this practice, newest
 * enrolment first, each with its percent and its current step (contract §5.4).
 *
 * Mount only once a client session exists (the endpoint answers 401 otherwise).
 *
 * @returns {{ data: object[]|null, loading: boolean, error: any, notFound: boolean,
 *             reload: () => Promise<void> }}
 */
export default function useMemberPathways() {
  const fetcher = useCallback(() => fetchMemberPathways(), []);
  return useMemberRead(fetcher);
}
